import get from 'lodash/get';

type Messages = Record<string, any>

const globalI18n = (typeof window === 'undefined')
  ? {
    locale: 'en',
    defaultLocale: 'en',
  }
  : window.I18n
;

export class MiniTranslator {
  messages: Messages;

  constructor(messages: Messages) {
    this.messages = messages;
  }

  t(translationKey: string): string {
    return (
      get(
        this.messages,
        `${globalI18n.locale}.${translationKey}`,

        // Fallback
        get(
          this.messages,
          `${globalI18n.defaultLocale}.${translationKey}`,

          // Fallback
          translationKey,
        ),
      )
    );
  }
}
